import React from 'react';
import Icon from '../../common/Icon/Icon';

/**
 * Form Select component with icon and label
 * @param {string} label - Select label
 * @param {string} icon - Icon name for left icon
 * @param {array} options - Array of { value, label } options
 * @param {string} value - Selected value
 * @param {function} onChange - Change handler
 * @param {string} placeholder - Placeholder text
 * @param {boolean} required - Whether select is required
 * @param {string} error - Error message
 */
const Select = ({
  label,
  icon,
  options = [],
  value,
  onChange,
  placeholder = 'Select an option',
  required = false,
  error,
  className = '',
  ...props
}) => {
  return (
    <div className={`space-y-2 group ${className}`}>
      {label && (
        <label className="form-label">
          {label}
          {required && <span className="text-red-400 ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        <select
          value={value}
          onChange={onChange}
          required={required}
          className={`
            w-full h-14 pr-10 bg-surface-highlight border border-[#2e3f57] rounded-xl 
            text-white appearance-none focus:ring-2 focus:ring-primary 
            focus:border-transparent outline-none transition-all text-base
            ${icon ? 'pl-12' : 'pl-4'}
            ${error ? 'border-red-500 focus:ring-red-500' : ''}
          `}
          {...props}
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {icon && (
          <Icon
            name={icon}
            className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 group-focus-within:text-primary transition-colors pointer-events-none"
          />
        )}
        <Icon
          name="expand_more"
          className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none"
        />
      </div>
      {error && (
        <p className="text-red-400 text-xs ml-1">{error}</p>
      )}
    </div>
  );
};

export default Select;
